import {gql} from '@apollo/client'

export const START_CHILDCARE_REQUEST = gql`
  query startChildcareRequest($employeeId: ID!) {
    client {
      employee(employeeId: $employeeId) {
        id
        staffCode
        displayFullName
        user {
          id
          email
        }
      }
    }
  }
`

export interface StartChildcareRequestQueryVariables {
  employeeId: string
}

export interface StartChildcareRequestQueryResult {
  client: {
    employee: Employee
  }
}

export interface Employee {
  id: string
  staffCode: string
  displayFullName: string
  user?: {
    id: string
    email: string
  }
}
